
import { useEffect, useState } from "react";
import styles from "../addBooking.module.css";
import { Delete } from "@mui/icons-material";
import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import axios from "axios";
import { authData } from "../../../../components/GetAuth";
import { NumericFormat } from "react-number-format";

const ProductComponent = ({ fields, append, errors, control, setValue, register, clearErrors, watch, cngProductVal, delItems }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [productList, setProductList] = useState([]);

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "v1/product-dd-list", {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`
            }
        }).then((response) => {
            if (response.data.status === "SUCCESS") {
                let allData = response.data.data;
                allData = allData.concat([{ id: 0, title: 'Other' }]);
                setProductList(allData);
            }
        });
    }, [API_TOKEN]);

    return (<div className={`${styles.BookADelivery}`}>
        <div className={`${styles.BookADeliveryCardArea}`}>
            {fields.map((item, index) => {
                return (<div className={`${styles.BookDeliveryCard}`} key={item.id} style={{ background: "#D1E7FC" }}>
                    <div className={`${styles.BookDeliveryCardUnder}`}>
                        <div className={`${styles.BookDeliveryCardUnderRow}`}>
                            <div className={`${styles.BookDeliveryFormCard25}`}>
                                <div className={`FormHalfGroup`}>
                                    <FormControl fullWidth>
                                        <InputLabel>Category*</InputLabel>
                                        <Controller
                                            key={item.id}
                                            control={control}
                                            {...register(`products[${index}].category_id`, { required: true })}
                                            render={({ field }) => (<Select
                                                {...field}
                                                label="Category*"
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    if (e.target.value) {
                                                        let selCat = productList?.filter((i) => i?.id === e.target.value);
                                                        if (selCat.length) {
                                                            selCat = selCat[0];
                                                            if (selCat?.no_of_child === 0) {
                                                                setValue(`products[${index}].item_id`, selCat?.id);
                                                                setValue(`products[${index}].item_name`, selCat?.title);
                                                                setValue(`products[${index}].total`, selCat?.amount);
                                                                setValue(`products[${index}].is_fragile`, selCat?.is_fragile === 1);
                                                                setValue(`products[${index}].is_item`, false);
                                                            } else {
                                                                setValue(`products[${index}].item_id`, "");
                                                                setValue(`products[${index}].item_name`, "");
                                                                setValue(`products[${index}].total`, "");
                                                                setValue(`products[${index}].is_fragile`, false);
                                                                setValue(`products[${index}].is_item`, true);
                                                            }
                                                            clearErrors();
                                                        }
                                                        cngProductVal();
                                                    } else {
                                                        setValue(`products[${index}].item_id`, 0);
                                                    }
                                                }}
                                            >
                                                {productList?.map((val) => {
                                                    return (val?.parent_id === 0 || val?.id === 0) ? (<MenuItem key={val?.id} value={val?.id}>{val?.title}</MenuItem>) : null;
                                                })}
                                            </Select>)}
                                        />
                                    </FormControl>
                                    {errors?.products?.length > 0 && errors?.products[index]?.category_id && (<p className={`${styles.ErrorM}`}>Please select category</p>)}
                                </div>
                            </div>

                            <div className={`${styles.BookDeliveryFormCard25}`}>
                                {watch(`products[${index}].category_id`) === 0 && (<div className={`FormHalfGroup`}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`products[${index}].item_name`, { required: true })}
                                        render={({ field }) => (<TextField
                                            {...field}
                                            label="Product*"
                                            variant="outlined"
                                            onChange={(e) => {
                                                field.onChange(e);
                                            }}
                                        />)}
                                    />
                                    {errors?.products?.length > 0 && errors?.products[index]?.item_name && (<p className={`${styles.ErrorM}`}>Please select item</p>)}
                                </div>)}
                                {(watch(`products[${index}].is_item`) && watch(`products[${index}].category_id`) !== 0) && (<div className={`FormHalfGroup`}>
                                    <FormControl fullWidth>
                                        <InputLabel>Item*</InputLabel>
                                        <Controller
                                            key={item.id}
                                            control={control}
                                            {...register(`products[${index}].item_id`, { required: true })}
                                            render={({ field }) => (<Select
                                                {...field}
                                                label="Item*"
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    if (e.target.value) {
                                                        let selProduct = productList?.filter((i) => i?.id === e.target.value);
                                                        if (selProduct.length) {
                                                            selProduct = selProduct[0];
                                                            setValue(`products[${index}].item_name`, selProduct?.parent?.title + "- " + selProduct?.title);
                                                            setValue(`products[${index}].total`, selProduct?.amount);
                                                            setValue(`products[${index}].is_fragile`, selProduct?.is_fragile === 1);
                                                            clearErrors();
                                                        }
                                                    }
                                                    cngProductVal();
                                                }}
                                            >
                                                {productList?.map((val) => {
                                                    return val?.parent_id === watch(`products[${index}].category_id`) ? (<MenuItem key={val?.id} value={val?.id}>{val?.title}</MenuItem>) : null;
                                                })}
                                            </Select>)}
                                        />
                                    </FormControl>
                                    {errors?.products?.length > 0 && errors?.products[index]?.item_id && (<p className={`${styles.ErrorM}`}>Please select item</p>)}
                                </div>)}
                            </div>

                            <div className={`${styles.BookDeliveryFormCard10}`}>
                                <div className={`${styles.FormField}`}>
                                    <FormControlLabel
                                        label="Fragile?"
                                        className={`${styles.CheckBox} CheckBox`}
                                        control={<Controller
                                            key={item.id}
                                            control={control}
                                            {...register(`products[${index}].is_fragile`)}
                                            render={({ field }) => (<Checkbox {...field} checked={field?.value} />)}
                                        />}
                                    />
                                </div>
                            </div>

                            <div className={`${styles.BookDeliveryFormCard20}`}>
                                <div className={`${styles.FormField}`}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`products[${index}].total`, { required: true })}
                                        render={({ field }) => (<NumericFormat
                                            {...field}
                                            label="Total*"
                                            variant="outlined"
                                            customInput={TextField}
                                            allowLeadingZeros={false}
                                            allowNegative={false}
                                            decimalScale={2}
                                            fixedDecimalScale
                                            onChange={(e) => {
                                                field.onChange(e);
                                                cngProductVal();
                                            }}
                                        />)}
                                    />
                                    {errors?.products?.length > 0 && errors?.products[index]?.total && (<p className={`${styles.ErrorM}`}>Please enter total amount</p>)}
                                </div>
                            </div>
                        </div>
                    </div>

                    <button className={`${styles.CardTrashBU}`} type="button" onClick={(e) => { delItems(e); }}><Delete /></button>
                </div>);
            })}

            <button className={`${styles.HomeBU}`} type="button" onClick={() => { append({ category_id: "", item_id: "", item_name: "", total: "", is_fragile: false, is_item: true }); }}>Add Items</button>
        </div>
    </div>);
}

export default ProductComponent;